/* Generated by restful-react */

import React from 'react'
import { Get, GetProps, useGet, UseGetProps } from 'restful-react'

export const SPEC_VERSION = 'v10'
export interface IParentUsersProps {
  nextPage: boolean
  addUserPermission?: boolean
  currentUserCompanyId?: number | null
  currentUserCompanyType?: 'shipper' | 'carrier' | '' | null
  parentUsers: IParentUserProps[]
}

export interface IParentUserProps {
  id: number
  email?: string
  firstName?: string
  lastName?: string
  typeName?: string
  stateName?: 'Approved' | 'Rejected' | 'Pending' | 'Deleted'
  phone?: string
  phoneExt?: string
  cellPhone?: string
  lastActivityAt?: string
  createdAt?: string
  applicationUser?: {
    createdAt?: string
    typeName?: string
    stateName?: 'Approved' | 'Rejected' | 'Pending' | 'Deleted'
  }
  companyDetails?: {
    id: number
    applicationId?: number
    applicationType?: string
    applicationTypePath?: string
    applicationName?: string
    roleName: string
  }[]
}

export interface GetParentUsersQueryParams {
  query?: string
  userType?: string
  companyType?: string
  companyQuery?: string
  applicationId?: number
  pageNumber?: number
  pageSize?: number
  sortOrder?: string
  sortField?: string
}

export type GetParentUsersProps = Omit<
  GetProps<IParentUsersProps, unknown, GetParentUsersQueryParams, void>,
  'path'
>

/**
 * Get Parent Users List
 */
export const GetParentUsers = (props: GetParentUsersProps) => (
  <Get<IParentUsersProps, unknown, GetParentUsersQueryParams, void>
    path='/v10/parent_users'
    {...props}
  />
)

export type UseGetParentUsersProps = Omit<
  UseGetProps<IParentUsersProps, unknown, GetParentUsersQueryParams, void>,
  'path'
>

/**
 * Get Parent Users List
 */
export const useGetParentUsers = (props: UseGetParentUsersProps) =>
  useGet<IParentUsersProps, unknown, GetParentUsersQueryParams, void>(`/v10/parent_users`, props)
